import { useEffect } from "react";
import { addChain } from "../utils/helper";

const AddChainPage = () => {
  useEffect(() => {
    const addNetworkAndRedirect = async () => {
      try {
        await addChain();
        window.location.href = "/"
      } catch (error) {
        console.error('Failed to add chain:', error);
      }
    };

    addNetworkAndRedirect();
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen text-black text-lg font-medium">
      <p className="flex items-center gap-1">
        Adding Vanar Chain
        <span className="animate-bounce">.</span>
        <span className="animate-bounce [animation-delay:0.2s]">.</span>
        <span className="animate-bounce [animation-delay:0.4s]">.</span>
      </p>
    </div>
  );
};

export default AddChainPage